var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* globals i18n */
/**
 * Renders answer bar for mobile graded groups. [STATELESS]
 */
var React = require("react");

var ApiOptions = require("../perseus-api.jsx").Options;
var InlineIcon = require("../components/inline-icon.jsx");

var _require = require("../icon-paths.js"),
    iconStar = _require.iconStar,
    iconTryAgain = _require.iconTryAgain;

var _require2 = require("../styles/constants.js"),
    boldFontFamily = _require2.boldFontFamily,
    gray68 = _require2.gray68,
    gray76 = _require2.gray76,
    gray85 = _require2.gray85,
    gray95 = _require2.gray95,
    kaGreen = _require2.kaGreen,
    phoneMargin = _require2.phoneMargin,
    negativePhoneMargin = _require2.negativePhoneMargin;

var ANSWER_BAR_STATES = {
    // Initial state before the question is answerable.  The user must complete
    // each of the widgets before the answer bar becomes visible.
    HIDDEN: Symbol("HIDDEN"),

    // The 'Check' button is active whenever the question is answerable or any
    // of the input widgets have been modified after getting the answer wrong.
    ACTIVE: Symbol("ACTIVE"),

    // The 'Check' button is disabled and there is no message.  This occurs when
    // some of the widgets haven't been filled in after the has already become
    // visible.
    INACTIVE: Symbol("INACTIVE"),

    // This happens immediately after clicking 'Check' with a wrong answer.
    // The 'Check' button is disabled and the 'Try Again' message is displayed.
    INCORRECT: Symbol("INCORRECT"),

    // Final state.  This occurs after the user submits the correct answer.
    // The widgets in this grade-group are disabled.
    CORRECT: Symbol("CORRECT")
};

var GradedGroupAnswerBar = React.createClass({
    displayName: "GradedGroupAnswerBar",

    propTypes: {
        // TODO(kevinb) update to oneOf once we update to 15.2
        answerBarState: React.PropTypes.any.isRequired,
        apiOptions: ApiOptions.propTypes,
        onCheckAnswer: React.PropTypes.func.isRequired,

        // The function to call when clicking "Next question" after correctly
        // answering one graded group out of a set. If this is null, the
        // "Next question" button will not appear.
        onNextQuestion: React.PropTypes.func
    },

    render: function render() {
        var _props = this.props,
            apiOptions = _props.apiOptions,
            answerBarState = _props.answerBarState,
            onCheckAnswer = _props.onCheckAnswer,
            onNextQuestion = _props.onNextQuestion;


        var answerBarStyle = _extends({}, styles.answerBar, {
            backgroundColor: answerBarState === ANSWER_BAR_STATES.CORRECT ? gray95 : "white",
            // Center the "Correct!" message only when there's no next question
            justifyContent: answerBarState === ANSWER_BAR_STATES.CORRECT && !onNextQuestion ? "center" : "space-between"
        });

        var buttonStyle = _extends({}, styles.button, {
            // "Check" and "Next question" buttons should both be green
            backgroundColor: answerBarState === ANSWER_BAR_STATES.ACTIVE || answerBarState === ANSWER_BAR_STATES.CORRECT ? kaGreen : gray85
        });

        var textStyle = _extends({}, styles.text, {
            color: answerBarState === ANSWER_BAR_STATES.CORRECT ? kaGreen : gray68
        });

        var message = answerBarState === ANSWER_BAR_STATES.INCORRECT ? React.createElement(
            "span",
            { style: textStyle },
            React.createElement(
                "span",
                { style: styles.tryAgainIcon },
                React.createElement(InlineIcon, iconTryAgain)
            ),
            React.createElement(
                "span",
                { style: { marginLeft: 8 } },
                i18n._("Keep trying")
            )
        ) : React.createElement("span", null); // empty span keeps the button on the right side

        if (answerBarState !== ANSWER_BAR_STATES.CORRECT) {
            var buttonLabel = answerBarState === ANSWER_BAR_STATES.INCORRECT ? i18n._("Try again") : i18n._("Check");

            // Use <button> instead of <input> b/c iOS 9.3 on iPhone 6 renders
            // the <input> as a faded out green button instead of using our
            // styles.
            return React.createElement(
                "div",
                { style: answerBarStyle },
                message,
                React.createElement(
                    "button",
                    {
                        style: buttonStyle,
                        disabled: apiOptions.readOnly || answerBarState !== ANSWER_BAR_STATES.ACTIVE,
                        onClick: onCheckAnswer
                    },
                    buttonLabel
                )
            );
        } else {
            return React.createElement(
                "div",
                { style: answerBarStyle },
                React.createElement(
                    "span",
                    { style: textStyle },
                    React.createElement(
                        "span",
                        { style: { fontSize: 28, color: "#FFB300" } },
                        React.createElement(InlineIcon, _extends({}, iconStar, {
                            style: { marginBottom: 5 }
                        }))
                    ),
                    React.createElement(
                        "span",
                        { style: { marginLeft: 8 } },
                        i18n._("Correct!")
                    )
                ),
                onNextQuestion && React.createElement(
                    "button",
                    { style: buttonStyle, onClick: onNextQuestion },
                    i18n._("Next question")
                )
            );
        }
    }
});

var fontSize = 17;

var styles = {
    answerBar: {
        display: "flex",
        alignItems: "center",
        height: 68, // so that we don't have calculate the vertical padding
        marginLeft: negativePhoneMargin,
        marginRight: negativePhoneMargin,
        marginBottom: negativePhoneMargin,
        marginTop: phoneMargin,
        paddingLeft: phoneMargin,
        paddingRight: 10,
        borderTop: "1px solid " + gray76
    },

    // TODO(kevinb) figure out a way inject styles/components from webapp
    button: {
        height: 48,
        width: 143,
        borderRadius: 4,
        color: "white",
        fontFamily: boldFontFamily,
        fontSize: fontSize,
        border: "none"
    },

    tryAgainIcon: {
        fontSize: 28,
        color: "#63D9EA",
        transform: "scale(-1,1) rotate(-268deg)"
    },

    text: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        fontFamily: boldFontFamily,
        fontSize: fontSize
    }
};

GradedGroupAnswerBar.ANSWER_BAR_STATES = ANSWER_BAR_STATES;

module.exports = GradedGroupAnswerBar;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/graded-group-answer-bar.jsx
 ** module id = 250
 ** module chunks = 0 1
 **/